// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

/* Two columns on wide screens, one on phones */
.password-criteria {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 6px 14px;
  margin: -4px 0 14px;
  padding: 0 4px;
  list-style: none;
}

.password-criteria__item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--ion-color-medium);
  transition: color 0.15s ease;
}
.password-criteria__item ion-icon {
  flex-shrink: 0;
  font-size: 16px;
}
.password-criteria__item--met {
  color: var(--ion-color-success-shade);
}`, "",{"version":3,"sources":["webpack://./src/components/general components/password-criteria/password-criteria.component.scss","webpack://./src/components/general%20components/password-criteria/password-criteria.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;ACCF;;ADEA,+CAAA;AACA;EACE,aAAA;EACA,4DAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,8BAAA;EACA,4BAAA;ACCF;ADCE;EACE,cAAA;EACA,eAAA;ACCJ;ADEE;EACE,qCAAA;ACAJ","sourcesContent":[":host {\n  display: block;\n}\n\n/* Two columns on wide screens, one on phones */\n.password-criteria {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n  gap: 6px 14px;\n  margin: -4px 0 14px;\n  padding: 0 4px;\n  list-style: none;\n}\n\n.password-criteria__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: var(--ion-color-medium);\n  transition: color 0.15s ease;\n\n  ion-icon {\n    flex-shrink: 0;\n    font-size: 16px;\n  }\n\n  &--met {\n    color: var(--ion-color-success-shade);\n  }\n}\n",":host {\n  display: block;\n}\n\n/* Two columns on wide screens, one on phones */\n.password-criteria {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n  gap: 6px 14px;\n  margin: -4px 0 14px;\n  padding: 0 4px;\n  list-style: none;\n}\n\n.password-criteria__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: var(--ion-color-medium);\n  transition: color 0.15s ease;\n}\n.password-criteria__item ion-icon {\n  flex-shrink: 0;\n  font-size: 16px;\n}\n.password-criteria__item--met {\n  color: var(--ion-color-success-shade);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
